import React from "react";

const WhyChooseConsulting: React.FC = () => {
  return (
    <div className="flex justify-center items-center w-full">
      <div className="grid gap-5">
        <div className="grid gap-5 grid-cols-2 md:grid-cols-3 xl:gap-12">
          <div className="p-3">
            <h4 className="font-light text-3xl lg:text-4xl max-w-xs xl:leading-normal">
              Why Choose Dream Weavers Recruitment Consulting?
            </h4>
          </div>

          <div className="flex flex-col gap-1 custom-hover md:gap-3 bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              01
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl ">
              Comprehensive Recruitment Strategies
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              Our expert-driven approach ensures tailored recruitment plans,
              including market analysis, talent sourcing, and placement
              strategies, for optimal results.
            </p>
          </div>
          <div className="flex flex-col gap-1 md:gap-3 custom-hover bg-[#34368A] text-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl">
              02
            </h3>
            <div className="font-medium xl:text-xl">
              Access to Highly Skilled Professionals Across Industries
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              Tap into our extensive network of professionals with diverse
              expertise, helping you fill niche roles and meet industry-specific
              talent needs.
            </p>
          </div>
          <div className="flex flex-col custom-hover gap-1 md:gap-3 bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              03
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              Fast and Efficient Hiring Processes
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              Streamline your hiring with our proven methodologies, cutting down
              recruitment time while ensuring top-quality candidates for your
              roles.
            </p>
          </div>
          <div className="flex flex-col custom-hover gap-1 md:gap-3 bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              04
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              Customized Workforce Solutions to Meet Your Specific Requirements
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              We design bespoke recruitment solutions that align with your
              organizational goals, ensuring the best talent for your unique
              needs.
            </p>
          </div>
          <div className="flex custom-hover rounded-xl w-full">
            <div className="relative w-full h-full md:h-56 lg:h-[18rem]">
              <img
                src="/consulting/div-bg.png"
                alt=""
                className=" bg-contain bg-center w-full h-full"
              />
              <p className="absolute text-xs bottom-0 p-5 xl:text-xl text-white font-light md:text-lg">
                Managing Your Workforce, So You Can Focus on Growth
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseConsulting;
